export default __webpack_public_path__ + "static/media/signouticon.58e95159.svg";